export default "__VITE_ASSET__B634CZJ8__"